import clsx from 'clsx'
import { useField } from 'formik'
import React from 'react'

import { DateTimeInput } from '@/components'

import { InputContainer } from '../Input/Input.styles'

interface Props {
  className?: string
  endHour?: number
  label?: string
  name: string
  startHour?: number
  timeIntervals?: number
  timeZone?: string
}

export const DateTimeInputControlled = ({
  className = '',
  endHour,
  name,
  label,
  startHour,
  timeIntervals,
  timeZone,
}: Props) => {
  const [field, { touched, error }, { setError, setValue }] = useField({ name, type: 'datetime-local' })

  const isError = touched && !!error

  const handleChange = (value: Date) => {
    setValue(value)
    setError(undefined)
  }

  return (
    <InputContainer className={className} isError={isError}>
      {label && (
        <label className="mb-2 font-medium leading-120 text-primary" htmlFor={name}>
          {label}
        </label>
      )}
      <DateTimeInput
        endHour={endHour}
        handleChange={handleChange}
        startHour={startHour}
        timeIntervals={timeIntervals}
        timeZone={timeZone}
        value={field?.value}
      />

      <div className={clsx('flex w-full', isError ? 'justify-between' : 'justify-end')}>
        {isError && <p className="mt-1 font-medium text-label-xs text-tertiary">{error}</p>}
      </div>
    </InputContainer>
  )
}
